import { useContext, useRef } from "react";
import { LoginService } from "../../service/LoginService";
import { AppFunctions, AppFunctionsContext } from "../base/App";

interface Props {

	/** 閉じる時処理 */
	onClose: () => void,
};

export default function ChangePassword(props: Props): JSX.Element {

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	/** 現在のパスワード */
	const oldPassword = useRef<HTMLInputElement | null>(null);

	/** 新しいパスワード */
	const newPassword = useRef<HTMLInputElement | null>(null);

	/** 新しいパスワード（再入力） */
	const confPassword = useRef<HTMLInputElement | null>(null);

	/**
	 * 確定ボタンクリック時イベント
	 */
	const handleCommitClick = async () => {
		if (oldPassword.current!.value == '') {
			alert('現在のパスワードを入力してください。');
			return;
		}
		if (newPassword.current!.value == '') {
			alert('新しいパスワードを入力してください。');
			return;
		}
		if (newPassword.current!.value != confPassword.current!.value) {
			alert('新しいパスワードの入力が一致していません。');
			return;
		}

		// サーバのパスワードを変更する。
		const res = await new LoginService(appFunctions!).changePassword(oldPassword.current!.value, newPassword.current!.value);
		if (res == true) {
			props.onClose();
		}
	};

	/**
	 * キャンセルボタンクリック時イベント
	 */
	const handleCancelClick = async () => {
		props.onClose();
	};

	// 描画する
	return (
		<div className="dialog">
			<div className="dialog-contents">
				<h4>パスワード変更</h4>
				<hr />
				<div className="control-group">
					<div>
						<table width="100%">
							<tbody>
								<tr>
									<td scope="row">現在のパスワード</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="password" name="oldPassword" size={35} ref={oldPassword} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">新しいパスワード</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="password" name="newPassword" size={35} ref={newPassword} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">新しいパスワード<br />（再入力）</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="password" name="confPassword" size={35} ref={confPassword} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row"></td>
									<td scope="row" colSpan={3} style={{ width: '250px' }}>
										<div>
											<p>確認のため新しいパスワードを再入力してください</p>
											<p>	※パスワードは、大文字・小文字・数字・記号の4種類を含めた半角文字10桁以上で設定してください。</p>
											<p>例）Abc000000@</p>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<hr />
				<div className="control-group">
					<div className="controls">
						<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleCommitClick}>変更</button>
						&nbsp;
						<button className="btn btn-default btn-secondary pull-center" type="button" onClick={handleCancelClick}>キャンセル</button>
					</div>
				</div>
			</div>
		</div>
	);
}